module.exports = __webpack_public_path__ + "static/img/wl1350.8132ac5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/wl1350.jpg
// module id = y083
// module chunks = 0